import { useTranslation } from '@/shared/lib/common/i18n';
import { useNewReleaseCheck } from '@/shared/lib/hooks/useNewReleaseCheck';
import { Box, Button, Stack } from '@mui/material';

/**
 * Slim bar above the app header (and at the top of the login page) telling the user a new build has been deployed. Never reloads on its
 * own: Refresh reloads now, Later hides it until the next release.
 */
const NewReleaseBanner = () => {
  const { t } = useTranslation();
  const { showBanner, reload, dismiss } = useNewReleaseCheck();

  if (!showBanner) return null;

  return (
    <Stack
      direction="row"
      sx={{
        // Full width even inside a centred column (the login page).
        alignSelf: 'stretch',
        backgroundColor: 'info.main',
        color: 'info.contrastText',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        py: 0.25,
        px: 2,
        fontSize: 13,
        fontWeight: 600
      }}
    >
      <Box component="span">{t.common.newRelease.bannerMessage}</Box>
      <Button color="inherit" size="small" onClick={reload} sx={{ fontWeight: 700, textDecoration: 'underline' }}>
        {t.common.actions.refresh}
      </Button>
      <Button color="inherit" size="small" onClick={dismiss}>
        {t.common.newRelease.later}
      </Button>
    </Stack>
  );
};

export default NewReleaseBanner;
